module.exports = __webpack_public_path__ + "static/character-cb8950217485b08c22db1a3951b0a880.svg";